<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="settings.xero-manage.xeroIntegrationSettings"
        [back]="true"
        backRoute="/settings/integrations-v2"
    ></app-header>

    <ui-banner variant="info" class="margin-bottom-2">
        {{ 'settings.xero-manage.pleaseNoteThatAnyNewMappingEnteredOrChangedHere' | translate }}
    </ui-banner>

    <ui-banner *ngIf="!isLoading && chartOfAccounts.length === 0" variant="danger" class="margin-bottom-2">
        {{ 'settings.xero-manage.weWereUnableToSyncYourXeroChartOfAccounts' | translate }}
    </ui-banner>

    <div class="ui segment">
        <app-header title="settings.xero-manage.xeroDataType"></app-header>
        <mat-label id="importAsBill_label" class="margin-bottom-2">
            <p
                [innerHTML]="
                    'settings.xero-manage.humiDataCanBeImportedIntoXeroAsEitherAbillOrJournalEntry' | translate
                "
            ></p
        ></mat-label>
        <mat-radio-group
            name="importAsBill"
            class="vertical"
            [(ngModel)]="importAsBill"
            (ngModelChange)="updateImportSetting()"
            aria-labelledby="importAsBill_label"
        >
            <mat-radio-button [value]="true" class="margin-bottom-2">{{
                'settings.xero-manage.importAsABill' | translate
            }}</mat-radio-button>
            <mat-radio-button [value]="false" class="margin-bottom-2">{{
                'settings.xero-manage.importAsAJournalEntry' | translate
            }}</mat-radio-button>
        </mat-radio-group>
    </div>

    <div class="ui segment">
        <app-header title="settings.xero-manage.accountMapping"></app-header>

        <p>{{ 'settings.xero-manage.matchYourHumiTransactionItemsOnTheLeftWithTheXeroAccount' | translate }}</p>
        <p>{{ 'settings.xero-manage.anyChangesMadeHereWillBeSavedAutomatically' | translate }}</p>

        <ng-container *ngFor="let group of accountMappingGroups; first as first; last as last">
            <div class="app-grid margin-top-4">
                <div class="columns-4">
                    <h3>{{ group[0] | titlecase }}</h3>
                </div>
                <div *ngIf="first" class="columns-4">
                    <h3>{{ 'settings.xero-manage.xeroAccountName' | translate }}</h3>
                </div>
            </div>
            <div class="app-grid" *ngFor="let mapping of group[1]">
                <div class="columns-4 align-self-center">{{ mapping.journalEntryReportItemTemplate.displayName }}</div>

                <div class="columns-4">
                    <mat-form-field style="width: 100%">
                        <mat-select
                            [(ngModel)]="mapping.code"
                            (selectionChange)="updateMapping(mapping, $event.value)"
                            placeholder="{{ 'settings.xero-manage.selectOne' | translate }}"
                        >
                            <mat-option *ngFor="let account of chartOfAccounts" [value]="account.code">
                                {{ account.code }} - {{ account.name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <hr *ngIf="!last" />
        </ng-container>
    </div>
</div>
